import Builder from './components/Builder'
import apiFetch from "@wordpress/api-fetch";

document.addEventListener("DOMContentLoaded", DOMContentLoadedImport);

function DOMContentLoadedImport() {


    var appData = {
        name: "Product Slider for FluentCart ",
        version: "1.0.0",
        demoUrl: "https://demo.pickplugins.com/pickplugins-product-slider-for-fluentcart/",
        reviewsUrl: "https://wordpress.org/support/plugin/pickplugins-product-slider-for-fluentcart/reviews/#new-post/"
    }

    window.PPSFC = {};
    window.PPSFC = appData;

    apiFetch({
        path: "/pickplugins-product-slider-for-fluentcart/v1/get_options",
        method: "POST",
        data: { option: "ppsfc_settings" },
    }).then((res) => {
        if (res.length != 0) {
            var resX = { ...res };
            var license_key = resX?.license_key;


            window.PPSFC = { ...appData, license_key: license_key };


        }
    });

    // console.log(window.PPSFC)

    setTimeout(() => {

        var builderWrap = document.querySelector('#builder');


        if (builderWrap != null) {
            wp.element.render(<Builder appData={appData} />, builderWrap)
        }
    }, 2000)



}



